import { render } from "./BacklogView.vue?vue&type=template&id=28efc144"
import script from "./BacklogView.vue?vue&type=script&lang=js"
export * from "./BacklogView.vue?vue&type=script&lang=js"

import "./BacklogView.vue?vue&type=style&index=0&id=28efc144&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__